import React from 'react'
import { Outlet } from 'react-router-dom'
import AdminHeader from './AdminCommon/AdminHeader'
// import Footer from '../Common/Footer'

const AdminLayout = () => {
  return (
    <>
        <AdminHeader/>
        <section className='admin-mid-wrap'>
          <Outlet />
        </section>
        {/* <Footer/> */}
    </>
  )
}

export default AdminLayout